import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesFemale({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#E3E8E8" cx={12} cy={12} r={12} />
        <path
          d="M12 5.4a4.22 4.22 0 01.75 8.38v1.07h1.59c.38 0 .69.28.74.65v.1c0 .41-.33.75-.74.75h-1.59v1.7c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.75-.75v-1.7H9.57a.75.75 0 01-.74-.65v-.1c0-.41.33-.75.74-.75h1.68v-1.07A4.22 4.22 0 017.8 9.83l-.01-.2A4.22 4.22 0 0112 5.4zm0 1.5a2.72 2.72 0 100 5.44 2.72 2.72 0 000-5.44z"
          fill="#666"
        />
      </g>
    </svg>
  );
}

SvgRulesFemale.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesFemale.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgRulesFemale svgRef={ref} {...props} />);
export default ForwardRef;
